const DOCTORS = [
  { initials: "AS", name: "Dr. A. Sharma", meta: "Cardiology · Available today" },
  { initials: "RI", name: "Dr. R. Iyer", meta: "Dermatology · Available tomorrow" },
];

const SLOTS = ["09:00", "10:30", "12:00", "16:15"];

export const DocCareMockup = () => (
  <div
    data-testid="doccare-app-mock"
    className="overflow-hidden rounded-xl border border-cream/15 bg-white text-navy"
  >
    <div className="flex items-center gap-2 border-b border-navy/10 bg-cream px-4 py-3">
      <span className="h-2.5 w-2.5 rounded-full bg-rust/70" />
      <span className="h-2.5 w-2.5 rounded-full bg-sage" />
      <span className="h-2.5 w-2.5 rounded-full bg-navy/25" />
      <span className="ml-3 flex-1 rounded-full border border-navy/10 bg-white px-3 py-1 text-[10px] text-navy/50">
        doccare — book appointment
      </span>
    </div>
    <div className="p-5">
      <div className="flex items-center justify-between">
        <p className="font-display text-lg font-semibold tracking-tight">DocCare</p>
        <span className="rounded-full bg-sage/60 px-3 py-1 text-[10px] font-medium uppercase tracking-wider">
          Book appointment
        </span>
      </div>
      <div className="mt-4 rounded-full border border-navy/15 px-4 py-2 text-xs text-navy/40">
        Search doctors, specialities…
      </div>
      <div className="mt-4 space-y-3">
        {DOCTORS.map((d) => (
          <div
            key={d.name}
            className="flex items-center gap-3 rounded-lg border border-navy/10 p-3"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xs text-cream">
              {d.initials}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-xs font-semibold">{d.name}</p>
              <p className="truncate text-[10px] text-navy/50">{d.meta}</p>
            </div>
            <span className="rounded-full border border-rust px-3 py-1 text-[10px] font-medium text-rust">
              Book
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {SLOTS.map((t, i) => (
          <span
            key={t}
            className={`rounded-md border px-2.5 py-1 text-[10px] ${
              i === 1
                ? "border-rust bg-rust text-white"
                : "border-navy/15 text-navy/60"
            }`}
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </div>
);
